module.exports = __webpack_public_path__ + "img/hic-other-heart-diseases-female.d7c65131.png";